export default __webpack_public_path__ + "static/media/Redux-Store.d5455aa0.png";